import { HttpInterceptorFn } from '@angular/common/http';

export const adAuthInterceptor: HttpInterceptorFn = (req, next) => next(req.clone({ withCredentials: true }));
